import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons';

const CalculatorForm = ({ values, errors, handleChange, translations, fetching,  data, loading }) => {
  return (
    <div>
      <h3 className="tw-text-2xl tw-mb-3">{!fetching && translations[0].i18n.page.info}</h3>
      <div className="tw-form-group tw-mb-4">
        <label className="tw-block tw-mb-2 tw-text-md tw-font-medium tw-text-gray-900">
          {!fetching && translations[0].i18n.province.label}
          <select
            name="landskap"
            value={values.landskap}
            onChange={handleChange}
            className="tw-bg-gray-50 tw-border tw-border-gray-300 tw-text-gray-900 tw-text-md tw-rounded-lg tw-focus:ring-blue-500 tw-focus:border-blue-500 tw-block tw-w-full tw-p-2.5"
          >
            <option value="">{!fetching && translations[0].i18n.province.placeholder}</option>
            {!loading && data.filter(item => item.vid === 'landskap').map(item => {
              return (
                <option
                  key={item.tid}
                  value={item.name}
                  data-tid={item.tid}
                  data-minorder={item.field_minimi_order}>
                  {item.name}
                </option>
              )
            })}
          </select>
        </label>
        {errors.landskap && (<div className="tw-text-red-600">{errors.landskap}</div>)}
      </div>
      <div className="tw-form-group tw-mb-4">
        <label className="tw-block tw-mb-2 tw-text-md tw-text-left tw-font-medium tw-text-gray-900">
          {!fetching && translations[0].i18n.squares.label}
          <input
            type="number"
            placeholder={!fetching ? translations[0].i18n.squares.placeholder : ''}
            min={values.min_order}
            max={4000}
            value={values.kvm}
            name="kvm"
            onChange={handleChange}
            className="tw-bg-gray-50 tw-border tw-border-gray-300 tw-text-gray-900 tw-text-md tw-rounded-lg tw-focus:ring-blue-500 tw-focus:border-blue-500 tw-block tw-w-full tw-p-2.5"
          />
        </label>
        {errors.kvm && (<div className="tw-text-red-600">{errors.kvm}</div>)}
      </div>
      <div className="tw-form-group tw-mb-4">
        <label className="tw-block tw-mb-2 tw-text-md tw-text-left tw-font-medium tw-text-gray-900">
          {!fetching && translations[0].i18n.floors.label}
          <select
            name="antal_plan"
            value={values.antal_plan}
            onChange={handleChange}
            className="tw-bg-gray-50 tw-border tw-border-gray-300 tw-text-gray-900 tw-text-md tw-rounded-lg tw-focus:ring-blue-500 tw-focus:border-blue-500 tw-block tw-w-full tw-p-2.5"
          >
            <option value="">{!fetching && translations[0].i18n.floors.placeholder}</option>
            {!loading && data.filter(item => item.vid === 'antal_plan').map(item => {
              return (
                <option
                  key={item.tid}
                  value={item.name}
                  data-tid={item.tid}
                  data-plantillagg={item.field_prispalagg}>
                  {item.name}
                </option>
              )
            })}
          </select>
        </label>
        {errors.antal_plan && (<div className="tw-text-red-600">{errors.antal_plan}</div>)}
      </div>
      <div className={values.plan_tillagg === 100 ? 'hidden' : 'visible'}>
        <div className="tw-form-group tw-mb-4">
          <label className="tw-block tw-mb-2 tw-text-md tw-text-left tw-font-medium tw-text-gray-900">
            {!fetching && translations[0].i18n.inclination.label}
            <div className="tw-grid tw-grid-cols-4 tw-gap-4">
              {!loading && data.filter(item => item.vid === 'lutning').map(item => {
                return (
                  <label key={item.tid} className={`tw-relative tw-flex tw-flex-col tw-items-center tw-justify-centertw-p-2 tw-border tw-py-5 ${values.lutning === item.name ? 'tw-border-4' : ''}`}>
                    <input
                      className="tw-self-end tw-opacity-0 tw-absolute"
                      type="radio"
                      name="lutning"
                      value={item.name}
                      data-tid={item.tid}
                      data-lutningstillagg={item.field_prispalagg}
                      checked={values.lutning === item.name}
                      onChange={handleChange}
                    />
                    <FontAwesomeIcon icon={faCheckCircle} className={`tw-absolute tw-top-1 tw-right-1 tw-text-amber-500 ${values.lutning === item.name ? 'tw-visible' : 'tw-invisible'}`}/>
                    <img src={item.field_icon} width={50} height={50} alt={item.name}/>
                    <span className="tw-text-sm tw-text-center">{item.name}</span>
                  </label>
                )
              })}
            </div>
          </label>
          {errors.lutning && (<div className="tw-text-red-600">{errors.lutning}</div>)}
        </div>
        <div className="tw-form-group tw-mb-4">
          <label className="tw-block tw-mb-2 tw-text-md tw-text-left tw-font-medium tw-text-gray-900">
            {!fetching && translations[0].i18n.color.label}
            <select
              name="farg"
              value={values.farg}
              onChange={handleChange}
              className="tw-bg-gray-50 tw-border tw-border-gray-300 tw-text-gray-900 tw-text-md tw-rounded-lg tw-focus:ring-blue-500 tw-focus:border-blue-500 tw-block tw-w-full tw-p-2.5"
            >
              <option value="">{!fetching && translations[0].i18n.color.placeholder}</option>
              {!loading && data.filter(item => item.vid === 'farg').map(item => {
                return (
                  <option
                    key={item.tid}
                    value={item.name}
                    data-tid={item.tid}
                    data-fargtillagg={item.field_prispalagg}>
                    {item.name}
                  </option>
                )
              })}
            </select>
          </label>
          {errors.farg && (<div className="tw-text-red-600">{errors.farg}</div>)}
        </div>
        <div className="tw-form-group tw-mb-4">
          {!loading && data.filter(item => item.tid === '44').map(item => {
            return (
              <label key={item.tid} className="tw-text-md tw-font-medium tw-text-gray-900 tw-flex tw-items-center">
                {!fetching && translations[0].i18n.tile.label}
                <input
                  name="tegelpanna_byte"
                  type="checkbox"
                  checked={values.tegelpanna_byte}
                  value={item.field_pris}
                  onChange={handleChange}
                  className="tw-ml-4 tw-w-6 tw-h-6 tw-text-blue-600 tw-bg-gray-100 tw-border-gray-300 tw-rounded tw-focus:ring-blue-500"
                />
              </label>
            )
          })}
          {values.tegelpanna_byte && <div>
            <label className="tw-text-md tw-text-left tw-font-medium tw-text-gray-900">
              {!fetching && translations[0].i18n.tile.qty}
              <input
                type="number"
                placeholder={!fetching ? translations[0].i18n.tile.placeholder : ''}
                min={0}
                value={values.tegelpanna_antal}
                name="tegelpanna_antal"
                onChange={handleChange}
                className="tw-bg-gray-50 tw-border tw-border-gray-300 tw-text-gray-900 tw-text-md tw-rounded-lg tw-focus:ring-blue-500 tw-focus:border-blue-500 tw-block tw-w-full tw-p-2.5" 
              />
            </label>
            <div>
              {!loading && data.filter(item => item.tid === '45').map(item => {
                return (
                  <label key={item.tid} className="tw-mt-4 tw-text-md tw-font-medium tw-text-gray-900 tw-flex tw-items-center">
                    {!fetching && translations[0].i18n.tile.spares}
                    <input
                      name="tegelpanna_lager"
                      type="checkbox" checked={values.tegelpanna_lager}
                      value={item.field_pris}
                      onChange={handleChange}
                      className="tw-ml-4 tw-w-6 tw-h-6 tw-text-blue-600 tw-bg-gray-100 tw-border-gray-300 tw-rounded tw-focus:ring-blue-500"
                    />
                  </label>
                )
              })}
            </div>
          </div>}
        </div>
        <div className="tw-form-group tw-mb-4">
          <label className="tw-text-md tw-font-medium tw-text-gray-900 tw-flex tw-items-center">
            {!fetching && translations[0].i18n.dropceiling.label}
            <input
              name="undertak"
              type="checkbox"
              checked={values.undertak}
              value={true}
              onChange={handleChange}
              className="tw-ml-4 tw-w-6 tw-h-6 tw-text-blue-600 tw-bg-gray-100 tw-border-gray-300 tw-rounded tw-focus:ring-blue-500"
            />
          </label>
        </div>
      </div>
    </div>
  );
};

export default CalculatorForm;
